export enum SignatureRoutePages {
  Root = '',
  AccessToken = 'access-token',
  Completed = 'completed',
  CompletedWithPendingSignatures = 'completed-with-pending-signatures',
  Envelope = 'envelope',
  Initial = 'initial',
  Denied = 'denied',
  Paused = 'paused',
  DocumentRejected  = 'document-rejected',
  alreadySigned = 'already-signed',
  alreadySignedConcluded = 'already-signed-concluded',
  qrCodeAuthDigitalCloud = 'auth-digital-cloud',
  ResponsibleAlreadyFilled = 'responsible-already-filled'
}